export default __webpack_public_path__ + "static/media/banner2.55398761.jpg";